export default "/_next/static/images/ff6f9770bb363588bc6abc3b335ab537.png";